const entities = {
  fieldLibrary: "ספריית שדות",
  fieldLibraryDesc: "שדות גלובליים לשימוש חוזר בכל ישות",
  entityTypes: "סוגי ישויות",
  entityTypesDesc: "תבניות המגדירות אילו שדות להציג בכל סוג פתק",
  newField: "שדה חדש",
  editField: "ערוך שדה",
  newType: "סוג חדש",
  editType: "ערוך סוג",
  metaKey: "מפתח מטא",
  fieldType: "סוג שדה",
  category: "קטגוריה",
  composite: "מורכב",
  subFields: "תת-שדות",
  addSubField: "הוסף תת-שדה",
  displayTemplate: "תבנית תצוגה",
  options: "אפשרויות",
  addOption: "הוסף אפשרות",
  label: "תווית",
  labelHe: "תווית (עברית)",
  labelEn: "תווית (אנגלית)",
  fields: "שדות",
  usedIn: "בשימוש ב",
  allCategories: "כל הקטגוריות",
  allTypes: "כל הסוגים",
  searchFields: "חפש שדות...",
  searchTypes: "חפש סוגי ישויות...",
  noFieldsFound: "לא נמצאו שדות",
  cancel: "ביטול",
  save: "שמור",
  create: "צור",
  slug: "מזהה (slug)",
  icon: "אייקון",
  color: "צבע",
  defaultView: "תצוגת ברירת מחדל",
  registryKind: "סוג רישום",
  registryKindHint: "מאגר = רשומה תפעולית (נוצרת/נערכת כאן) · ספריה = רכיב מערכת-עיצוב · קטלוג = רשימת-ייחוס חיצונית, קריאה בלבד",
  registryKindOptions: { "מאגר": "מאגר — רשומה תפעולית", "ספריה": "ספריה — רכיב מערכת-עיצוב", "קטלוג": "קטלוג — רשימת-ייחוס חיצונית (קריאה בלבד)" },
  selectFields: "בחר שדות",
  inheritedFrom: "יורש מ־",
  inheritedFieldsHint: "שדות שמסומנים «יורש» מגיעים מסוג האב ואינם נשמרים על הסוג הזה",
  selectGroups: "בחר קבוצות חוזרות",
  connections: "חיבורים",
  sourceType: "מקור",
  targetType: "יעד",
  relationLabel: "תווית קשר",
  add: "הוסף",
  viewNotes: "צפה בפתקים",
  views: { table: "טבלה", board: "לוח", list: "רשימה", calendar: "לוח שנה", gantt: "גאנט", timeline: "ציר זמן", gallery: "גלריה", stream: "סטרים" },
  searchNotes: "חפש פתקים...",
  newNote: "פתק חדש",
  records: "רשומות",
  filter: "סנן",
  contains: "מכיל",
  isEmpty: "ריק",
  isNotEmpty: "לא ריק",
  addFilter: "הוסף מסנן",
  prev: "הקודם",
  next: "הבא",
  loading: "טוען...",
  entityNotFound: "סוג ישות לא נמצא",
  versionConflict: "השינוי לא נשמר — ייתכן שהרשומה השתנתה מאז שנפתחה. הנתונים רועננו, נסו שוב",
  linkedNotes: "פתקים מקושרים",
  link: "קשר",
  searchToLink: "חפש פתק לקישור...",
  stakeholders: "בעלי עניין",
  addStakeholder: "הוסף בעל עניין",
  searchContact: "חפש איש קשר...",
  primary: "ראשי",
  additional: "נוספים",
  access: "גישה",
  notify: "עדכונים",
  role: "תפקיד",
  activity: "פעילות",
  comment: "תגובה",
  callLog: "שיחה",
  showInactive: "הצג לא פעילים",
  hideInactive: "הסתר לא פעילים",
  deactivate: "השבת",
  reactivate: "הפעל מחדש",
  inactive: "לא פעיל",
  zoom: "זום",
  day: "יום",
  week: "שבוע",
  month: "חודש",
  noGanttData: "אין נתונים לתצוגת גאנט",
  noTimelineData: "אין נתונים לציר הזמן",
  devTask: "משימת פיתוח",
  deal: "עסקה",
  lead: "ליד",
  agreement: "הסכם",
  kpiEvents: "אירועי KPI",
  activityLog: "לוג פעילות",
  backToList: "חזרה לרשימה",
  lastEdited: "עודכן",
  createdAt: "נוצר",
  confirmDelete: "למחוק לצמיתות?",
  actions: {
    allActions: "כל הפעולות",
    deactivate: "השבת",
    reactivate: "הפעל מחדש",
    changeStatus: "שנה סטטוס",
    exportCsv: "ייצוא CSV",
    openInAi: "פתח ב-AI",
    sendNotification: "שלח התראה",
    callLog: "תיעוד שיחה",
    sendWhatsapp: "שלח WhatsApp",
    confirmDeactivate: "האם להשבית את הפתק?",
    confirmBulkDeactivate: "האם להשבית את הפתקים שנבחרו?",
    bulkSelected: "נבחרו",
    noActions: "אין פעולות זמינות",
    bulkStatusChange: "שינוי סטטוס גורף",
    bulkAssignTitle: "הקצאה גורפת",
    assigneePlaceholder: "שם המוקצה...",
    applyAssign: "החל הקצאה",
    noStatusOptions: "אין אפשרויות סטטוס",
  },
  bulk: {
    title: "עדכון שדה גורף",
    stepField: "בחר שדה",
    stepValue: "הגדר ערך",
    stepPreview: "תצוגה מקדימה",
    settingValueFor: "הגדרת ערך עבור",
    next: "הבא",
    apply: "החל שינויים",
    recordsAffected: "רשומות יושפעו",
    record: "רשומה",
    currentValue: "ערך נוכחי",
    newValueLabel: "ערך חדש",
    more: "נוספים",
  },
  saveFailed: "השמירה נכשלה",
  tabGeneral: "כללי",
  tabTemplate: "תבנית",
  templates: "תבניות",
  addTemplate: "הוסף תבנית",
  browseTemplates: "עיון בתבניות",
  linkedTemplates: "תבניות מקושרות",
  openFullEditor: "פתח בעורך",
  noTemplates: "אין תבניות",
  linkTemplate: "קשר תבנית",
  unlinkTemplate: "בטל קישור",
  createTemplate: "צור תבנית חדשה",
  accessDenied: "אין הרשאה",
  adminOnly: "פעולה זו מוגבלת למנהלים",
  roleAdmin: "מנהל",
  roleManager: "מנהל צוות",
  roleMember: "חבר",
  roleViewer: "צופה",
  roleExternal: "חיצוני",
  savedViews: "תצוגות שמורות",
  saveView: "שמור תצוגה",
  viewName: "שם תצוגה",
  deleteView: "מחק תצוגה",
  noSavedViews: "אין תצוגות שמורות",
  savedViewPrivate: "רק אני רואה",
  savedViewsLoadFailed: "טעינת התצוגות השמורות נכשלה",
  viewSaveFailed: "שמירת התצוגה נכשלה",
  viewDeleteFailed: "מחיקת התצוגה נכשלה",
  viewSaved: "תצוגה נשמרה",
  viewDeleted: "תצוגה נמחקה",
  allRecords: "כל הרשומות",
  aliases: "שמות חלופיים",
  addAlias: "הוסף שם חלופי",
  noAliases: "אין שמות חלופיים",
  mergeField: "מזג לשדה",
  mergeWarning: "meta_key הישן יהפוך ל-alias — הנתונים הקיימים לא ייפגעו",
  autoGenerated: "נוצר אוטומטית",
  aliasSource: "מקור",
  aliasManual: "ידני",
  aliasMerged: "מוזג",
  fieldMerged: "השדה אוחד בהצלחה",
  groupByCategory: "קיבוץ לפי קטגוריה",
  flatList: "רשימה רגילה",
  confirmDeleteField: "למחוק את השדה?",
  fieldUsedWarning: "שדה זה בשימוש. מחיקה עלולה לגרום לאובדן נתונים",
  tryDifferentSearch: "נסה מילות חיפוש אחרות",
  noFieldsYet: "אין שדות עדיין",
  createFirstField: "צור שדה ראשון",
  validation: "ולידציה",
  required: "שדה חובה",
  uniqueValue: "ערך ייחודי",
  patternRegex: "תבנית (Regex)",
  defaultValue: "ערך ברירת מחדל",
  noDefault: "ללא ברירת מחדל",
  dragToReorder: "גרור לשינוי סדר",
  descriptionHe: "תיאור (עברית)",
  descriptionEn: "תיאור (אנגלית)",
  clientDisplayNameHe: "שם תצוגה ללקוח (עברית)",
  clientDisplayNameEn: "שם תצוגה ללקוח (אנגלית)",
  clientDisplayNameHint: "השם שהלקוח יראה בטפסים ובאזור האישי. ברירת מחדל: שם השדה",
  storyCardRefs: "כרטיסי Story Map",
  noStoryCardRefs: "אין כרטיסים מקושרים",
  viewInStoryMap: "צפייה במפת סיפור",
  systemFields: "שדות מערכת",
  systemField: "שדה מערכת",
  systemFieldLocked: "שדה מערכת — לא ניתן למחיקה",
  universalFields: "שדות אוניברסליים",
  valuesWithoutField: "ערכים ללא שדה",
  viewCards: "כרטיסים",
  viewList: "רשימה",
  viewCompact: "טבלה",
  fieldInfo: "מידע על השדה",
  fieldPurpose: "מהות השדה",
  fieldUsage: "שימוש",
  fieldSettings: "הגדרות",
  optionsCount: "אפשרויות",
  hasValidation: "ולידציה",
  hasColorRules: "חוקי צבע",
  hasVisibilityRules: "חוקי הצגה",
  isReadOnly: "לקריאה בלבד",
  noDescription: "אין תיאור",
  totalFields: "סה\"כ שדות",
  searchByAll: "חפש בשם, מפתח, תיאור, קטגוריה...",
  tabSystem: "שדות מערכת",
  tabLibrary: "ספריית שדות",
  systemFieldsInfo: "שדות מערכת מגיעים מובנים ומוחלים אוטומטית על כל ישות. לא ניתן למחוק או לערוך אותם.",
  libraryFieldsInfo: "כאן אתה יוצר שדות חדשים ומנהל את הספרייה שלך. שדות אלו זמינים לבחירה כשאתה בונה סוג ישות.",
  tips: {
    validation: "ולידציה = כללי תקינות. מגדיר האם השדה חובה, האם הערך חייב להיות ייחודי (לא חוזר), ומהו הפורמט הנדרש.",
    required: "שדה חובה = חייב למלא ערך. לא ניתן לשמור את הפתק בלי למלא שדה זה.",
    unique: "ערך ייחודי = אותו ערך לא יכול להופיע פעמיים. למשל: מספר ת.ז, מספר חשבונית.",
    pattern: "תבנית (Regex) = פורמט ספציפי שהערך חייב לעמוד בו. למשל: מספר טלפון ישראלי, כתובת אימייל.",
    minMax: "מינימום / מקסימום = טווח מותר לערך. עבור מספר: ערך מספרי. עבור טקסט: אורך מינימלי/מקסימלי של תווים.",
    metaKey: "מפתח מטא = מזהה טכני של השדה ב-DB. נוצר אוטומטית מהשם. משמש לחיבור נתונים.",
    fieldType: "סוג השדה קובע איזה סוג מידע ניתן להכניס: טקסט חופשי, מספר, בחירה מרשימה, תאריך, ועוד.",
    category: "קטגוריה = קיבוץ לוגי של שדות. עוזר למצוא שדות מהר ולסנן לפי נושא.",
    composite: "שדה מורכב = מכיל תת-שדות בתוכו. למשל: כתובת מלאה עם רחוב, עיר, מיקוד.",
    options: "אפשרויות = רשימת הבחירות האפשריות בשדה בחירה. כל אפשרות עם שם וצבע.",
    aliases: "שמות חלופיים = מפתחות נוספים שמפנים לאותו שדה. שימושי כשמאחדים שדות או מייבאים נתונים.",
    visibilityRules: "חוקי הצגה = מתי להציג את השדה. למשל: הצג 'סיבת סגירה' רק כשסטטוס = 'סגור'.",
    colorRules: "חוקי צבע = צבע רקע דינמי לפי הערך. למשל: אדום כשימי חופשה < 3, ירוק כשהושלם > 70%.",
    readOnly: "לקריאה בלבד = השדה מוצג אבל לא ניתן לערוך אותו ידנית. מתעדכן אוטומטית מהמערכת.",
    defaultValue: "ערך ברירת מחדל = הערך שיוכנס אוטומטית כשיוצרים פתק חדש.",
    description: "תיאור = הסבר מה השדה עושה ולמה הוא משמש. מוצג בinfo של השדה.",
    icon: "אייקון = סמל ויזואלי שמייצג את השדה. מוצג ליד שם השדה בטפסים ובטבלאות.",
    merge: "מיזוג = איחוד שני שדות לאחד. המפתח הישן הופך לalias, הנתונים הקיימים לא נפגעים.",
    sortOrder: "סדר = המיקום של השדה ברשימה. ניתן לשנות ע\"י גרירה.",
    entityType: "סוג ישות = 'עדשה' שמגדירה אילו שדות להציג. אותו פתק יכול להיראות אחרת בכל סוג.",
    templateConfig: "תבנית = הגדרות מתקדמות: פריסה, תצוגות זמינות, הגדרות לוח/גאנט, כפתורי פעולה.",
    connections: "חיבורים = קשרים בין סוגי ישויות. למשל: לקוח → נכס, ספק → חשבונית.",
    fieldGroups: "קבוצות חוזרות = אוסף שדות שחוזר על עצמו. למשל: לוג שיחות, לוג תשלומים.",
  },
  activityLabels: { field_change: "שינוי שדה", status_change: "שינוי סטטוס", comment: "תגובה", call_log: "שיחה", relation_added: "קשר נוסף", relation_removed: "קשר הוסר", stakeholder_added: "בעל עניין נוסף", stakeholder_removed: "בעל עניין הוסר", created: "נוצר", deactivated: "הושבת", reactivated: "הופעל מחדש", deleted: "נמחק" },
  timeNow: "עכשיו",
  timeMinutesAgo: "לפני {n} דק׳",
  timeHoursAgo: "לפני {n} שע׳",
  timeDaysAgo: "לפני {n} ימים",
  addCommentPlaceholder: "הוסף תגובה...",
  callSummaryPlaceholder: "סיכום שיחה...",
  noActivityYet: "אין פעילות עדיין",
  comments: { title: "תגובות", reply: "הגב", edit: "ערוך", delete: "מחק", edited: "(נערך)", deleteConfirm: "בטוח למחוק?", writeComment: "כתוב תגובה...", noComments: "אין תגובות עדיין", replyingTo: "מגיב ל...", justNow: "עכשיו", reactions: "תגובות" },
  notifyAll: "הכל",
  notifyMilestones: "אבני דרך",
  notifyMentions: "אזכורים",
  notifyNone: "ללא",
  noStakeholdersYet: "אין בעלי עניין עדיין",
  tabOptions: "אפשרויות",
  tabValidation: "ולידציה",
  tabVisibility: "חוקי הצגה",
  tabColors: "חוקי צבע",
  tabAliases: "כינויים",
  readOnlyField: "שדה לקריאה בלבד",
  visibilityRulesLabel: "חוקי הצגה",
  visibilityRulesDesc: "השדה יוצג רק אם כל התנאים מתקיימים. שדה חובה מוסתר — לא נאכף.",
  addCondition: "הוסף תנאי",
  fieldAlwaysVisible: "השדה מוצג תמיד (ללא תנאים)",
  valuePlaceholder: "ערך",
  colorRulesLabel: "חוקי צבע",
  colorRulesDesc: "צבע השדה ישתנה בהתאם לתנאים. הכלל הראשון שמתקיים קובע.",
  addColorRule: "הוסף חוק",
  noColorRules: "ללא חוקי צבע (צבע ברירת מחדל)",
  addRow: "הוסף שורה",
  setupGuide: "מדריך הקמת ישויות",
  stepByStep: "צעד אחר צעד",
  openLink: "פתח",
  templateNamePlaceholder: "שם התבנית...",
  noTimelineDataDisplay: "אין נתונים להצגה בציר הזמן",
  noStreamDataDisplay: "אין עדיין פעילות להצגה",
  noDateFieldDefined: "אין שדה תאריך מוגדר בישות זו",
  tabGeneralType: "כללי",
  tabTemplateType: "תבנית",
  titleColumn: "כותרת",
  noRecords: "אין רשומות",
  noGanttDataDisplay: "אין נתונים להצגה בתצוגת גאנט",
  ganttZoom: "זום",
  ganttDay: "יום",
  ganttWeek: "שבוע",
  ganttMonth: "חודש",
  boardAll: "הכל",
  boardNone: "ללא",
  boardHideEmpty: "הסתר עמודות ריקות",
  columnBrowser: "דפדפן עמודות",
  noStatusFieldFound: "לא נמצא שדה סטטוס",
  callSummaryActionPlaceholder: "תקציר שיחה...",
  noConnectionsDefined: "אין חיבורים מוגדרים",
  connectionDiagram: "דיאגרמת קשרים",
  linksCount: "קשרים",
  relations: "קשרים",
  addRelation: "הוסף קשר",
  searchToLinkRelation: "חפש ישות לקישור...",
  noRelations: "אין קשרים עדיין",
  removeRelation: "הסר קשר",
  linkedEntities: "ישויות מקושרות",
  bulkBar: {
    nSelected: "נבחרו",
    updateStatus: "עדכן סטטוס",
    updateField: "עדכן שדה",
    deactivate: "השבת",
    delete: "מחק",
    confirmDelete: "למחוק את הפתקים שנבחרו?",
    confirmDeactivate: "להשבית את הפתקים שנבחרו?",
    apply: "החל",
    success: "הפעולה בוצעה בהצלחה",
    selectField: "בחר שדה",
    enterValue: "הזן ערך...",
    partial: "בוצעו {ok}, נכשלו {failed}",
    allFailed: "הפעולה נכשלה — לא שונו רשומות",
  },
  entityCanvas: {
    frame: "מסגרת",
    linkGraph: "גרף קישורים",
    navLog: "לוג גלישה",
    addBlock: "הוסף בלוק",
    emptyCanvas: "גרור בלוקים לכאן — תיקיות, שדות, קבוצות, פלאגינים",
    emptyGraph: "גרף הקישורים של הישות יוצג כאן",
    emptyHistory: "עדיין אין היסטוריית גלישה",
    noRelations: "אין קשרים עדיין",
    title: "כותרת",
    type: "סוג",
    time: "זמן",
    newBlock: "בלוק חדש",
    folder: "תיקייה",
    field: "שדה",
    fieldGroup: "קבוצת שדות",
    note: "פתק",
    plugin: "פלאגין",
    pickBlockType: "בחר סוג בלוק",
    pickField: "בחר שדה",
    comingSoon: "בקרוב",
    linkedEntities: "ישויות מקושרות",
    noLinked: "אין ישויות מקושרות",
    whiteboard: "vCanvas",
  },
  csvImport: {
    importCsv: "ייבוא CSV",
    uploadTitle: "העלאת CSV",
    uploadDesc: "גרור קובץ CSV לכאן או לחץ לבחירה",
    dropHere: "שחרר את הקובץ כאן",
    browse: "בחר קובץ",
    fileSelected: "קובץ נבחר",
    rowCount: "שורות",
    mapFields: "מיפוי שדות",
    csvColumn: "עמודת CSV",
    entityField: "שדה ישות",
    skipColumn: "-- דלג --",
    autoMapped: "זוהה אוטומטית",
    preview: "תצוגה מקדימה",
    importButton: "ייבוא",
    importing: "מייבא...",
    importComplete: "הייבוא הושלם בהצלחה",
    importError: "שגיאה בייבוא",
    step1: "העלאה",
    step2: "מיפוי",
    step3: "ייבוא",
  },
} as const;
export default entities;
